import { useQuery } from "@tanstack/react-query";
import { getApiIntegrationsProductItemsNorthmillAccountCodes } from "apiClients/base-generated";
import { getHeyApiRequestOptions, normalizeHeyApiLang } from "apiClients/base/heyApiRequestOptions";

function heyApiResultToError(err: unknown): Error {
  const message = typeof err === "string" ? err : JSON.stringify(err);
  return new Error(message);
}

export const DEFAULT_NORTHMILL_ACCOUNT_CODES_PAGE_SIZE = 500;

export type NorthmillAccountCodesQueryOptions = {
  pageSize?: number;
};

export function useNorthmillAccountCodesQuery(locale: string | null | undefined, options?: NorthmillAccountCodesQueryOptions) {
  const lang = normalizeHeyApiLang(locale);
  const pageSize = options?.pageSize ?? DEFAULT_NORTHMILL_ACCOUNT_CODES_PAGE_SIZE;

  return useQuery({
    queryKey: ["northmill-account-codes", lang ?? "default", pageSize],
    queryFn: async () => {
      const result = await getApiIntegrationsProductItemsNorthmillAccountCodes({
        ...getHeyApiRequestOptions(lang),
        query: { pageSize },
      });
      if (result.error) {
        throw heyApiResultToError(result.error);
      }
      return result.data ?? null;
    },
  });
}
